<template>
    <div v-if="isVisible">
        <div class="pl-4 pt-3 pb-4">
            <h5>Complaint details</h5>
        </div>
        <v-row no-gutters>
            <v-col cols="12" class="px-2">                         
                <v-data-table dense 
                    :headers="getHeaders()"
                    :items="hkrg" 
                    :disable-pagination=true hide-default-footer item-key="hkrg_encrid">    
                    <template v-slot:item="hkrg">
                    <tr> 
                        <td class="row-default">{{ $moment(hkrg.item.hkrg_dt).format("DD-MM-YYYY HH:mm") }}</td>
                        <td class="row-default">{{ hkrg.item.hkrg_oms }}</td>
                        <td class="row-default">{{ hkrg.item.hkrg_klst_display }}</td>
                        <td class="row-default">{{ hkrg.item.gebr_naam }}</td>
                        <td class="row-default"><v-btn x-small text icon v-on:click="updHkrg(hkrg.item.hkrg_encrid)"><v-icon small>mdi-wrench</v-icon></v-btn></td>
                        <td class="row-default">
                            <span v-if="hkrg.item.can_delete">
                                <v-btn x-small text icon v-on:click="rmHkrg(hkrg.item.hkrg_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                            </span>
                            <span v-else> <!-- uitlijning knoppen andere regels -->
                                <v-btn x-small text icon disabled><v-icon small></v-icon></v-btn>
                            </span>
                        </td>
                    </tr>                                         
                    </template>   
                </v-data-table>                    
            </v-col>
        </v-row>
        <v-row dense>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small text icon v-bind="attrs" v-on="on"
                           v-on:click="addHkrg()"
                           class="mr-7 mb-2 gridbutton"><v-icon small>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Add new event for {{ this.key }} </span>
            </v-tooltip>                
        </v-row>
        <updHkrg ref="updHkrg" @updateData="updateData"/>
    </div>
</template>

<script>

import updHkrg from '@/components/huov/hokl/updHkrg.vue';

export default {
    props: {
        isVisible: {
            type: Boolean,
            default: false
        },
    },          
    components: {    
        updHkrg,
    },
    data() {
        return {
            key: '',
            hokl_encrid: '',
            hkrg: [],
        }
    }, 
    methods: {
        open(hokl_encrid, key){
            this.key = key  
            this.hokl_encrid = hokl_encrid
            this.$emit('updateField', {field: 'showDetails', value: !this.isVisible});
            if(!this.isVisible){
                this.getHkrg(hokl_encrid);
            }
        },
        getHkrg(hokl_encrid) {
            this.$axios
                .post("ares/json/ares/huov/hokl/getHkrg.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHkrg"
                    },
                    getHkrg: {
                        hokl_encrid: hokl_encrid,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hkrg = res.data.getHkrg;
                    }
                });
        },
        updHkrg(hkrg_encrid) {
            this.$refs.updHkrg.open(hkrg_encrid);
        },      
        addHkrg(){
            this.$emit('executeFunction',  [
                {field: 'function', value: 'add_complaint_event'},  
                {field: 'encrid', value: this.hokl_encrid},  
                {field: 'key', value: this.key}
            ]);
        },  
        rmHkrg(hkrg_encrid){
            this.$axios
                .post("ares/json/ares/huov/hokl/rmHkrg.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmHkrg"
                    },
                    rmHkrg: {
                        hkrg_encrid: hkrg_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.updateData();
                    }
                });   
        },      
        updateData(){
           this.$emit('updateData', 'refresh');
        },      
        getHeaders(){
            return [
                { text: "Date/time", sortable: false,  width: "18%"},
                { text: "Description", sortable: false, width: "50%"},
                { text: "Status", sortable: false, width: "20%"},
                { text: "User", sortable: false, width: "20%"},
                { sortable: false, align: "start", width: "5%"},
                { sortable: false, align: "start", width: "5%"},
            ];
        },
    }
}
</script>

<style scoped>
  .row-default {
    cursor: default;
    vertical-align: top;
    border-top: 5px solid transparent;    
    font-size: 14px !important;
  }  
  .gridbutton{
    border: 1px solid rgba(169, 169, 169, 1) !important;
  }
</style>